/*
 * Copyright (c) 2023. American Express Company
 */

// third-party
import React from 'react';

// models and services
import { ChoiceCardViewModel } from 'src/types/view-models/choice-card.view.model';
import { CardStyleType } from 'src/types/card-type.enum';

// components
import { CardRounded } from '@americanexpress/dls-react';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// icons and styles
import styles from './ChoiceCard.module.scss';
import Selectors from 'src/utils/selectors';

export default function ChoiceCard({
    label,
    labelElement,
    description,
    descriptionElement,
    icon,
    type,
    onClick,
    children
}: ChoiceCardViewModel): JSX.Element {
    const choiceCardStyles: string =
        type === CardStyleType.SPECIAL ? styles.choiceCardSelected : styles.choiceCardDefault;

    const renderLabel: JSX.Element = label ? (
        <Typography variant={TypographyVariants.SUBTEXT_BOLD}> {label} </Typography>
    ) : (
        labelElement
    );

    const renderDescription: JSX.Element = description ? (
        <Typography variant={TypographyVariants.SUBTEXT}> {description} </Typography>
    ) : (
        descriptionElement
    );

    return (
        <CardRounded
            data-cy={Selectors.General.CHOICE_CARD}
            className={choiceCardStyles}
            type={type}
            onClick={() => {
                void onClick();
            }}
        >
            <div className={styles.choiceCardInner}>
                {icon}
                <div className={styles.choiceCardDetails}>
                    {renderLabel}
                    {renderDescription}
                </div>
                {children}
            </div>
        </CardRounded>
    );
}
